<template>
  <div class="TjPlug">
    <!-- 条件插件 -->
    <el-popover placement="bottom" width="900" v-model="plugShowFlag" trigger="manual">
      <div>
        <el-row>
          <el-col :span="24">
            <ValuePlug ref="prevValuePlugEle" :tableId="tableId" v-model="prevValuePlugInfo" :sourceType="0" @callback="prevValuePlugAfter" style="display: inline-block;"></ValuePlug>
            <el-select v-model="operator_check" placeholder="运算符" @change="operatorChange" value-key="value" style="display: inline-block;">
              <!-- <template slot="prefix"><span style="font-size: 1px;" >运算符:</span></template> -->
              <el-option
                v-for="(item,index) in operator_arr"
                :key="index"
                :label="item.label"
                :value="item"
                v-show="item.ifShow"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <!-- @change="funChange" -->
            <el-select v-if="dicJson.length > 0" v-model="dicCheckValue" value-key="DIC_ID" placeholder="请选择字典值" style="float: left;" clearable >
                <el-option
                  v-for="(dic,index) in dicJson"
                  :key="index"
                  :label="dic.DIC_NAME"
                  :value="dic"
                >
                </el-option>
            </el-select>
            <ValuePlug ref="valueValuePlugEle" :tableId="tableId" v-model="valueValuePlugInfo" :sourceType="valueValuePlugSourceType" @callback="valueValuePlugAfter" style="float: left;"></ValuePlug>
            <ValuePlug ref="valueXnTableValuePlugEle" v-if="xnTableId > 0" :tableId="xnTableId" v-model="valueXnTableValuePlugInfo" :sourceType="valueXnTableValuePlugSourceType" :ifManualInput="false" @callback="valueValuePlugAfter" style="float: left;"></ValuePlug>
            
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <input class="signbtn1" type="button" @click="signBtnClick('(')" value="(">
            <input class="signbtn1" type="button" @click="signBtnClick(')')" value=")">
            <input class="signbtn1" type="button" @click="signBtnClick('and')" value="and">
            <input class="signbtn1" type="button" @click="signBtnClick('or')" value="or">
            <input class="signbtn1" type="button" @click="signBtnClick('ok')" value="ok">
            <input class="signbtn1" type="button" @click="signBtnClick('←')" value="←">
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <span>值内容:</span>
          </el-col>
          <el-col :span="20">
            <div>
              <el-input slot="reference" v-model="value.nameStr" type="textarea" style="float:left;" >
                <el-button slot="append" icon="el-icon-search"></el-button>
              </el-input>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <input class="" type="button" value="取消" @click="closePlug">
            <input class="" type="button" value="确定" @click="savePlug">
          </el-col>
        </el-row>
      </div>
      <el-input slot="reference" v-model="value.nameStr" style="" @focus="openPlug" ><template slot="prepend">条件插件</template></el-input>
    </el-popover>
  </div>
</template>

<script>
import pageUtils from '@/js/page/pageUtil.js';
import utils from '@/js/utils/util.js';
export default {
  name: 'TjPlug',
  props: {
    /**初始的valueStr */
    value:{
      type: Object,
      default:function () {
        return {
          nameStr:"",
          resultStr:"",
          tjPlugId:0
        }
      }
    },
    // 对象主键
    tableId:{
      type:String
    },
    xnTableId:{
      type:String
    },
    // 结果的字段类型
    initSourceType:{
      default:0
    },
    //是否保存插件
    ifSavePlug:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      //显示隐藏状态
      plugShowFlag:false,
      prevCondition:[],
      prevOperate:[],
      valueInput:[],
      operate:[],
      nameEle:[],
      operator_check:null,
      operator_value:0,
      /**
       * 主键的支持的函数信息
       */
      operator_arr:[{label:"等于",value:0, ifShow:true},{label:"不等于",value:1, ifShow:true},{label:"小于",value:2, ifShow:true},{label:"大于",value:3, ifShow:true},{label:"小于等于",value:4, ifShow:true},{label:"大于等于",value:5, ifShow:true},{label:"包含",value:6, ifShow:true},{label:"不包含",value:7, ifShow:true},{label:"起始字符",value:8, ifShow:true},{label:"结束字符",value:9, ifShow:true},{label:"为空",value:10, ifShow:true},{label:"不为空",value:11, ifShow:true},{label:"设为搜索条件",value:12, ifShow:true},{label:"字符包含",value:13, ifShow:true},{label:"字符不包含",value:14, ifShow:true}],
      // 前置条件的值插件信息
      prevValuePlugInfo:{
        nameStr:"",
        resultStr:"",
        valuePlugId:0
      },
      //值插件的信息
      valueValuePlugInfo:{
        nameStr:"",
        resultStr:"",
        valuePlugId:0
      },
      valueValuePlugSourceType:0,
      //值插件虚拟表的信息
      valueXnTableValuePlugInfo:{
        nameStr:"",
        resultStr:"",
        valuePlugId:0
      },
      valueXnTableValuePlugSourceType:0,
      //数据字典字段的值
      dicJson:[],
      dicCheckValue:null
    };
  },
  created() {
    var that = this;
    that.sourceType = that.initSourceType;
  },
  mounted() {
    
  },
  watch:{
  },
  computed:{
  },
  components: {
    ValuePlug:resolve => require(['@/components/page/pageUtil/ValuePlug.vue'], resolve),
  },
  methods: {
    /**
     * 打开值插件设置页面
     */
    openPlug:function(){
      var that = this;
      this.plugShowFlag = true;
    },
    /**
     * 保存值插件
     */
    savePlug:function(){
      var that = this;
      var operateArr = that.operate;
      var leftKhNum = that._getNumChar(operateArr, "(");
      var rightKhNum = that._getNumChar(operateArr, ")");
      if(leftKhNum == rightKhNum) {
        //获取需要传送到后台的 字符串内容信息
        if(that.prevCondition.length > 0) {
          var resultStr = that.getToHtStr();
          that.value.resultStr = resultStr;
          if(that.ifSavePlug) {
            //后台保存值插件
            var url = "plug_addTjPlug.do";
            var toHtData = {};
            toHtData.tjPlugId = that.value.tjPlugId;
            toHtData.tjStr = resultStr;
            utils.request(that,{
              url: url, 
              data: toHtData,
              success: function (res) {
                console.log(res.data);
                if(res.data) {
                  that.value.tjPlugId = res.data;
                  console.log("res.data========valuePlugId===========",that.value.tjPlugId);
                  // that.$emit("callback");
                  that.closePlug();
                }
              }
            })
          } else {
            // that.$emit("callback");
            that.closePlug();
          }
        } else {
          // that.$emit("callback");
          that.closePlug();
        }
      } else {
        alert("左右括号个数必须相等");
      }
    },
    closePlug:function(){
      console.log("tjPlug====close=11122====",this.value);
      this.$emit("callback");
      this.plugShowFlag = false;
    },
    /**
     * 获取值插件的 传递到后台保存的字符串
     */
    getToHtStr : function() {
      var that = this;
      var prevConditionArr = that.prevCondition;
      var prevOperateArr = that.prevOperate;
      var valueInputArr = that.valueInput;
      var operateArr = that.operate;	
      var nameEleArr = that.nameEle;

      var prevConditionStr = prevConditionArr.join(" fml ");
      var prevOperateStr = prevOperateArr.join(" fml ");
      var valueInputStr = valueInputArr.join(" fml ");
      var operateStr = operateArr.join(" fml ");
      var nameEleStr = nameEleArr.join(" fml ");

      var resultStr = "";
      if(prevConditionStr.length > 0) {
        resultStr = prevConditionStr + " yqx " + prevOperateStr + " yqx " 
          + valueInputStr + " yqx " + operateStr + " yqx " + nameEleStr;
      }
      return resultStr;
    },
    /**
     * 点击确定时进行值插件字段的选中
     */
    confrimPlugField:function(){
      var that = this;
      
      that.closePlugField();
    },
    /**
     * 关闭字段选择弹出层
     */
    closePlugField:function(){
      var that = this;
      that.plugFieldData.plugFieldFlag = false;
    },
    
    /**
     * 运算符选择时的触发操作
     */
    operatorChange:function(operatorOne){
      this.operator_value = operatorOne.value;
    },
    
    /**
     * 加减乘除等符号的点击事件
     */
    signBtnClick:function(signValue){
      var that = this;
      var operateArr = that.operate;
      var flag = false;
      var message = "";
      if(signValue == "(") {
        if(operateArr.length == 0) {
          flag = true;
        } else {
          var lastEle = operateArr[operateArr.length-1];
          if(lastEle == "and" || lastEle == "or" || lastEle == "(") {
            flag = true;
          } else {
            flag = false;
          }
        }
        if(!flag) {
          message = "左括号必须在开头或 and 或 or 后面!";
        }
      } else if(signValue == ")") {
        if(operateArr.length == 0) {
          flag = false;
        } else {
          var lastEle = operateArr[operateArr.length-1];
          if(lastEle == ")" || lastEle == "") {
            var leftKhNum = that._getNumChar(operateArr, "(");
            var rightKhNum = that._getNumChar(operateArr, ")");
            if(leftKhNum > rightKhNum) {
              var value = $(this).val();
              flag = true;
            } else {
              flag = false;
            }
          } else {
            flag = false;
          }
        }
        if(!flag) {
          message = "右括号必须在结尾 或者 条件后面,并且左括号个数大于右括号个数!";
        }
      } else if(signValue == "and") {
        if(operateArr.length == 0) {
          flag = false;
        } else {
          var lastEle = operateArr[operateArr.length-1];
          if(lastEle == ")" || lastEle == "") {
            flag = true;
          } else {
            flag = false;
          }
        }
        if(!flag) {
          message = "and必须在条件 或者 右括号之后!";
        }
      } else if(signValue == "or") {
        if(operateArr.length == 0) {
          flag = true;
        } else {
          var lastEle = operateArr[operateArr.length-1];
          if(lastEle == ")" || lastEle == "") {
            flag = true;
          } else {
            flag = false;
          }
        }
        if(!flag) {
          message = "or必须在条件 或者 右括号之后!";
        }
      } else if(signValue == "ok") {
        if(operateArr.length == 0) {
          flag = true;
        } else {
          var lastOperateArr = operateArr[operateArr.length-1];
          if(lastOperateArr != "" && lastOperateArr != ")") {
            flag = true;
          } else {
            flag = false;
          }
        }
        if(!flag) {
          message = "条件 不可以在 右括号 和 条件之后!";
        }
      } else if(signValue == "←") {
        if(operateArr.length == 0) {
	        flag = false;
        } else {
          flag = true;
        }
        if(!flag) {
          message = "已删除完毕!";
        }
      }
      if(flag) {
        that._successOpera(signValue);
      } else {
        alert(message);
      }
    },
    //点击按钮时的触发逻辑
    _successOpera:function(operateOne){
      var that = this;
      var prevConditionArr = that.prevCondition;
      var prevOperateArr = that.prevOperate;
      var valueInputArr = that.valueInput;
      var operateArr = that.operate;	
      var nameEleArr = that.nameEle;
      var cnName = "";
      if(operateOne == "ok") {
        var flag = true;
        var tmpCnName = "[";
        var prevResultStr = that.prevValuePlugInfo.resultStr;
        if(prevResultStr && prevResultStr != "") {
          // prevConditionArr[prevConditionArr.length] = prevResultStr;
          tmpCnName += that.prevValuePlugInfo.nameStr;
        } else {
          flag = false;
        }
        if(that.operator_check) {
          // prevOperateArr[prevOperateArr.length] = that.operator_check.value;
          tmpCnName += " " + that.operator_check.label + " ";
        } else {
          flag = false;
        }
        //如果虚拟值插件选中了 取虚拟值插件
        //如果值插件选中了 取值插件
        //如果数据字典选中了 去数据字典
        var valueXnResultStr = that.valueXnTableValuePlugInfo.resultStr;
        var valueResultStr = that.valueValuePlugInfo.resultStr;
        var valueTmpResultStr = "";
        if(valueXnResultStr && valueXnResultStr != "") {
          valueTmpResultStr = "xn_" + valueXnResultStr;
          tmpCnName += that.valueXnTableValuePlugInfo.nameStr + "]";
        } else if(valueResultStr && valueResultStr != "") {
          valueTmpResultStr = valueResultStr;
          tmpCnName += that.valueValuePlugInfo.nameStr+ "]";
        } else if(that.dicJson.length > 0 && that.dicCheckValue && that.dicCheckValue.DIC_ID >= 0) {
          valueTmpResultStr = ((that.dicCheckValue.DIC_ID!=null && that.dicCheckValue.DIC_FLAG!=undefined)?that.dicCheckValue.DIC_FLAG:"dic") + "_" + that.dicCheckValue.DIC_ID;
          tmpCnName += that.dicCheckValue.DIC_NAME+ "]";
        } else {
          flag = false
        }
        if(flag) {
          prevConditionArr[prevConditionArr.length] = prevResultStr;
          prevOperateArr[prevOperateArr.length] = that.operator_check.value;
          valueInputArr[valueInputArr.length] = valueTmpResultStr;
          operateArr[operateArr.length] = "";
          nameEleArr[nameEleArr.length] = tmpCnName;
        } else {
          alert("不是完整有效的条件");
        }
      } else if(operateOne == "←") {
        prevConditionArr.pop();
        prevOperateArr.pop();
        valueInputArr.pop();
        operateArr.pop();
        nameEleArr.pop();
      } else {
        prevConditionArr[prevConditionArr.length] = "";
        prevOperateArr[prevOperateArr.length] = "";
        valueInputArr[valueInputArr.length] = "";
        operateArr[operateArr.length] = operateOne;
        nameEleArr[nameEleArr.length] = operateOne;
      }
      cnName = nameEleArr.join(" ");
      that.value.nameStr = cnName;
      that.$forceUpdate();
      console.log("_successOpera=======================",that);
    },
    //获取 左括号 或 右括号的个数
    _getNumChar : function(allEle, kh){
      var num = 0;
      allEle.forEach((one,i) => {
        if(one.indexOf(kh)>=0) {
          num ++;
        }
      });
      return num;
    },
    //前置条件插件 选中回调
    prevValuePlugAfter:function(){
      var that = this;
      var prevValuePlugEle = that.$refs.prevValuePlugEle;
      //根据前置条件的 值插件返回类型 切换比较运算符的显示内容
      console.log("prevValuePlugEle====================================",prevValuePlugEle);
      var resultTypeArr = prevValuePlugEle.resultTypeArr;
      var lasCheckFieldOne = prevValuePlugEle.plugFieldData.checkFieldOne;
      var lastResultType = resultTypeArr==null?-1:resultTypeArr[resultTypeArr.length-1];
      //根据字段的返回值类型 进行比对条件和 值内容的切换
      that.changeOperaAndValue(lastResultType,lasCheckFieldOne);	  
      // self.fieldChoose.val("");
      // self.fieldChoose.data(null);
      that.valueValuePlugSourceType = lastResultType;
      that.valueXnTableValuePlugSourceType = lastResultType;
      
      // 0:主键 2:富文本  18:单文档 19:多文档  16:单值选择项 17:多值选择项 23:星期 
      //self.prevValue.children().remove();
      //1:包含虚拟的当前对象
      // if(options.xnTableId > 0) {
      //   var xnValueInput = $('<input value="" name="valueInput"  readonly="readonly"/>');
      //   self.xnValueInput = xnValueInput;
      //   self.prevValue.append(xnValueInput);
      //   xnValueInput.lmfValuePlug({
      //     tableId : options.xnTableId,
      //     sourceType : lastResultType
      //   });
      // }
    },
    //值的值插件 选中回调
    valueValuePlugAfter:function(){

    },
    changeOperaAndValue:function(nodeType,lasCheckFieldOne){
      var that = this;
      that.dicJson = [];
      var operator_arr = that.operator_arr;
      that.prevOperate = [];
			that.prevValue = [];
      
      operator_arr.forEach((element,index) => {
        element.ifShow = false;
        var operatorIndexStr = "";
        switch(parseInt(nodeType)) {
					//字符 不用考虑 selectValue的值    包含 不包含  等于 不等于 起始字符 结束字符
					//0字符 1富文本 4密码 5身份证 6Email 16规则生成  19名称 20地址 为字符类型
					case 2:
            operatorIndexStr = ",0,1,6,7,8,9,10,11,12,13,14,";
					  break;
					case 1:
						//数据类型  数据  金额 
            operatorIndexStr = ",0,1,2,3,4,5,10,11,12,";
					  break;
					case 3:
						//日期
            operatorIndexStr = ",0,1,2,3,4,5,10,11,12,";
					  break;
					case 16:
					case 17:
          case 23:
          case 4:
						//单值选项和多值选项
            operatorIndexStr = ",0,1,6,7,10,11,";
						if(nodeType == 11) {
              operatorIndexStr = ",6,7,10,11,";
						}
					break;
					case 18:
					case 19:
						//单文档  多文档
            operatorIndexStr = ",10,11,";
					break;
					case 14:
					case 15:
					case 25:
					case 27:
						//内部对象  内部对象多值
						//单值选项和多值选项
            operatorIndexStr = ",0,1,10,11,12,";
						if(nodeType == 15) {
              operatorIndexStr = ",0,1,10,11,12,";
						}
					break;
					default:
					break;
				}	
        if(operatorIndexStr.indexOf("," + element.value + ",")>=0) {
          element.ifShow = true;
        }
      });

      //根据字段id进行 数据字典值的查询
      if(parseInt(nodeType) == 16 || parseInt(nodeType) == 17 || parseInt(nodeType) == 23 || parseInt(nodeType) == 4) {
        var url = "plug_getDicByFieldId.do";
        var toHtData={fieldId:lasCheckFieldOne.fieldId};
        utils.request(that,{
          url: url, 
          data: toHtData,
          success: function (res) {
            var dicJson = res.data;
            if(dicJson) {
              that.dicJson = dicJson;
            }
          },
          fail: function () {
          }
        });
      }
    }
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .signbtn1 {
      float: left;
      height: 24px;
      line-height: 20px;
      border: 1px solid #dddddd;
      background: #f9f9f9;
      padding: 0 3px;
      cursor: pointer;
      margin: 0 3px;
      font-family: 'microsoft yahei';
      color: #666666;
  }
  .edus_inputInside {
    float: left;
    width: 250px;
    height: 20px;
    line-height: 20px;
    text-align: left;
  }
  .field_span{
    margin: 3px 10px;
    padding: 0 5px;
  }
  .field_span_sel{
    color: #3f84e9;
    border: 1px solid #3f84e9;
  }
</style>
